// extracted by mini-css-extract-plugin
export var checkbox = "section-dropdown-module--checkbox--Ohoyr";
export var container = "section-dropdown-module--container--lUZDX";
export var content = "section-dropdown-module--content--NZsef";
export var empty = "section-dropdown-module--empty--AxogJ";
export var icon = "section-dropdown-module--icon--RsbXU";
export var label = "section-dropdown-module--label--M4Jsv";
export var title = "section-dropdown-module--title---Eutn";